module.exports = __webpack_public_path__ + "static/media/phone.37b4f62b.svg";